import { Languages } from "lucide-react";
import { useLang } from "@/content/ContentContext";
import { useT } from "@/content/i18n";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const t = useT();
  const other = lang === "fr" ? "en" : "fr";
  return (
    <button
      data-testid="lang-toggle-button"
      onClick={() => setLang(other)}
      className={`chip ${className}`}
      aria-label={t("switchTo")}
      title={t("switchTo")}
    >
      <Languages className="h-4 w-4" />
      <span className="font-mono text-xs tracking-[0.15em]">
        <span className={lang === "fr" ? "text-[#E69C24]" : "text-[#C5BDB3]"}>FR</span>
        <span className="mx-1 text-[#C5BDB3]">/</span>
        <span className={lang === "en" ? "text-[#E69C24]" : "text-[#C5BDB3]"}>EN</span>
      </span>
    </button>
  );
};
